import { requestFile, requestGet, requestPost } from '@/utils/request'

export function fileUpload(params){
  return requestFile('/common/upload', params);
}
